import { useEffect, useState } from "react";
import onepass_model from "../../../models/onepass_model";

export const useOnePassDiscount = () => {
  const [onepassDiscount, setOnepassDiscount] = useState(null);

  useEffect(() => {
    const fetchOnepassDiscount = async () => {
      const discount = await onepass_model.getOnePassDiscount();
      setOnepassDiscount(discount);
    };
    fetchOnepassDiscount();
  }, [setOnepassDiscount]);

  return onepassDiscount;
};
